module.exports = __webpack_public_path__ + "media/images/brand-assets/dark_2-edc2f215ca1a9b603c752bc39f8e83d5.png";